import { render, staticRenderFns } from "./LenderOtherBrands.vue?vue&type=template&id=50acfd42&scoped=true&"
import script from "./LenderOtherBrands.vue?vue&type=script&lang=js&"
export * from "./LenderOtherBrands.vue?vue&type=script&lang=js&"
import style0 from "./LenderOtherBrands.vue?vue&type=style&index=0&id=50acfd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50acfd42",
  null
  
)

export default component.exports